<section class="app-screen">
    <div class="app-screen__container">
        <div class="container">
            <div class="row">
                <div class="col-sm-4">
                    <div class="app-logo-wrapper text-center">
                        <div class="app-logo-wrapper__logo">
                            <img
                                src="/assets/layout/images/azara-logo.svg"
                                alt="Logo"
                            />
                        </div>
                    </div>
                </div>

                <div class="col-sm-8 col-md-6">
                    <div class="app-form">
                        <div class="app-form__wrapper app-form__wrapper--lg">
                            <div class="app-form__wrapper__inner">
                                <ng-content></ng-content>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<footer class="app-footer">
    <img
        src="/assets/layout/images/azara-logo-white.svg"
        alt="Logo"
        class="app-footer__logo"
        height="40px"
    />
</footer>
